// Signup wizard entry. Distinct from apps/portal/src/main.tsx — no
// OIDC client, no TanStack Query (we manage our own fetches), no
// router. The wizard owns its own routing via current-step state.

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './styles.css';

const root = document.getElementById('root');
if (!root) throw new Error('signup: #root element missing');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
